import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Linkedin, MessageCircle, Phone, Mail } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_gen-z-jewels-1/artifacts/8dp6l3ul_nova.png";

const Footer = () => {
  return (
    <footer className="bg-[#2D3B26] text-[#E4E8DF]">
      <div className="max-w-7xl mx-auto px-6 py-14">
        {/* Logo */}
        <div className="flex flex-col items-center mb-12">
          <h2 className="text-2xl font-serif font-bold text-[#FDFBF7] tracking-tight">NOVA</h2>
          <span className="text-[10px] uppercase tracking-[0.25em] text-[#E4E8DF]/50 font-medium mt-1">New Gold Era</span>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mb-12">

          {/* 1. Know Your Jewellery */}
          <div>
            <h3 className="text-xs uppercase tracking-widest font-semibold text-[#FDFBF7] mb-4">Know Your Jewellery</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/jewelry-guide" data-testid="footer-jewelry-guide" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors">Jewellery Guide</Link>
              </li>
              <li>
                <a href="#" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors">Gold Rate</a>
              </li>
              <li>
                <Link to="/size-guide" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors">Size Guide</Link>
              </li>
            </ul>
          </div>

          {/* 2. Nova Advantage */}
          <div>
            <h3 className="text-xs uppercase tracking-widest font-semibold text-[#FDFBF7] mb-4">Nova Advantage</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/policies#returns" data-testid="footer-returns" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors">30 Days Return</Link>
              </li>
              <li>
                <Link to="/policies#warranty" data-testid="footer-warranty" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors">Lifetime Warranty</Link>
              </li>
              <li>
                <Link to="/policies#buyback" data-testid="footer-buyback" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors">Lifetime Buyback</Link>
              </li>
              <li>
                <Link to="/policies#free-shipping" data-testid="footer-free-shipping" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors">Free Delivery</Link>
              </li>
              <li>
                <Link to="/policies#certified" data-testid="footer-certified" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors">Certified Jewellery</Link>
              </li>
            </ul>
          </div>

          {/* 3. Customer Service */}
          <div>
            <h3 className="text-xs uppercase tracking-widest font-semibold text-[#FDFBF7] mb-4">Customer Service</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/policies#returns" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors">Return Policy</Link>
              </li>
              <li>
                <Link to="/orders" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors">Order Status</Link>
              </li>
            </ul>
          </div>

          {/* 4. About Nova */}
          <div>
            <h3 className="text-xs uppercase tracking-widest font-semibold text-[#FDFBF7] mb-4">About Nova</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/about" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors">Our Story</Link>
              </li>
            </ul>
          </div>

          {/* 5. Contact Us */}
          <div>
            <h3 className="text-xs uppercase tracking-widest font-semibold text-[#FDFBF7] mb-4">Contact Us</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="#" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors flex items-center gap-2">
                  <MessageCircle size={14} /> Live Chat
                </a>
              </li>
              <li>
                <a href="tel:+919876543210" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors flex items-center gap-2">
                  <Phone size={14} /> +91 98765 43210
                </a>
              </li>
              <li>
                <a href="mailto:hello@novajewels.com" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors flex items-center gap-2">
                  <Mail size={14} /> hello@novajewels.com
                </a>
              </li>
            </ul>
          </div>

          {/* 6. Follow Us */}
          <div>
            <h3 className="text-xs uppercase tracking-widest font-semibold text-[#FDFBF7] mb-4">Follow Us</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="#" data-testid="social-instagram" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors flex items-center gap-2">
                  <Instagram size={16} /> Instagram
                </a>
              </li>
              <li>
                <a href="#" data-testid="social-facebook" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors flex items-center gap-2">
                  <Facebook size={16} /> Facebook
                </a>
              </li>
              <li>
                <a href="#" data-testid="social-linkedin" className="text-[#E4E8DF]/70 hover:text-[#C27054] transition-colors flex items-center gap-2">
                  <Linkedin size={16} /> LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-[rgba(228,232,223,0.15)] pt-8 text-center text-sm text-[#E4E8DF]/50">
          <p>&copy; 2026 NOVA Jewels. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
